import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7b0dba46&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0dba46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\huixin\\云商\\V12_saas版\\erp-flexible-web21-cloud-saas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b0dba46')) {
      api.createRecord('7b0dba46', component.options)
    } else {
      api.reload('7b0dba46', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7b0dba46&scoped=true", function () {
      api.rerender('7b0dba46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogBox/index.vue"
export default component.exports